import React, { Component, Fragment, createRef } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import { postAPI_ForgotPin } from '../../constants/APIs';
import { NotificationManager } from '../../components/common/react-notifications';
import aiva_background from '../../assets/aiva_background.png';
import aiva_logo from '../../assets/aiva_logo.png';
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
class ForgotPin extends Component {
  constructor(props) {
    super(props);
    this.myRef = createRef();
    this.state = {
      email: '',
      loading: false,
      process: false,
      vaildation: { email: "", recaptacha: "", msg: "" }
    };
  }
  handleChangeEmail = (email) => {
    this.setState({
      email: email.target.value,
    });
  };

  onUserForgot() {
    const token = this.myRef.current.getValue();
    let isValid = true;
    let errors = {};
    if (this.state.email === '') {
      isValid = false;
      errors.email = 'Please enter email';
    }
    if (this.state.email !== '') {
      if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)
      ) {
        isValid = false;
        errors.email = 'Invalid email address';
      }
    }
    if (this.state.email !== "" && errors.email === undefined && token === '') {
      isValid = false;
      errors.recaptacha = 'Please Verify the Recaptcha';
    }
    this.setState({ vaildation: errors });
    if (isValid) {
      this.setState({ process: true, loading: true });
      this.myRef.current.reset();
      let data = {
        email: this.state.email,
        source: 'aiva'
      };
      const recaptacha = {
        token: token,
        inputData: data
      }
      AxiosPublicAPI({
        method: 'post',
        url: `${postAPI_ForgotPin}`,
        data: recaptacha,
      }).then(
        (res) => {
          if (res.data !== "not verified") {
            this.setState({ loading: false });
          } else {
            this.setState({ process: false, loading: false });
          }
          // NotificationManager.success(
          //   'Please check your email',
          //   'Forgot Password Success',
          //   3000,
          //   null,
          //   null,
          //   'success'
          // );
        },
        (error) => {
          var errormsg = "";
          if (error.response.data.message === "ThrottlerException: Too Many Requests") {
            errormsg = "You have attempted many times. Please try after sometime.";
          }
          this.setState({ vaildation: { msg: errormsg } });
          console.log('eee.data', error.data);
        }
      );
    }
  }

  render() {
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">
                a voucher distribution system for savvy tourism businesses
              </p>
              <p className="white mb-0">
                Please use your e-mail to reset your pin.
              </p>
            </div>
            <div className="form-side">
              {!this.state.process && (
                <Fragment>
                  <NavLink to={`/`} className="white">
                    <span class="logo-single">
                      {' '}
                      <img
                        src={aiva_logo}
                        width="150"

                      />{' '}
                    </span>
                  </NavLink>
                  <CardTitle className="mb-4">
                    <IntlMessages id="user.forgot-pin" />
                  </CardTitle>
                  <Form>
                    <Label className="form-group has-float-label mb-4">
                      <Input
                        type="email"
                        defaultValue={this.state.email}
                        onChange={this.handleChangeEmail}
                      />
                      <IntlMessages id="user.email" />
                      {this.state.vaildation.email && (
                        <div className="invalid-feedback d-block">
                          {this.state.vaildation.email}
                        </div>
                      )}
                    </Label>
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                      ref={this.myRef}
                    />
                    {this.state.vaildation.recaptacha && (
                      <div className="invalid-feedback d-block">
                        {this.state.vaildation.recaptacha}
                      </div>
                    )}
                    <div className="d-flex justify-content-end align-items-center mt-2">
                      <Button
                        color="primary"
                        className="btn-shadow aiva-background "
                        size="lg"
                        onClick={() => this.onUserForgot()}
                      >
                        <IntlMessages id="user.reset-password-button" />
                      </Button>
                    </div>
                  </Form>
                </Fragment>
              )}

              {this.state.process &&
                (this.state.loading ? (
                  <Fragment>
                    {this.state.vaildation && this.state.vaildation.msg ?
                      <div className="text-center">
                        <Spinner color="primary" className="mb-1" />
                        <p>{this.state.vaildation.msg}</p>
                      </div>
                      :
                      <div className="text-center">
                        <Spinner color="primary" className="mb-1" />
                        <p>Your request is in progress</p>
                      </div>
                    }
                  </Fragment>
                ) : (
                  <div className="text-center">
                    <h2 className="mb-5">
                      Your pin reset email has been sent!
                    </h2>
                    <p className="mb-2">
                      We have sent a pin reset email to your email address.
                      Please check your inbox/junk to continue.
                    </p>
                  </div>
                ))}
            </div>
          </Card>
        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ settings }) => {
  const { checkPin } = settings;
  return {
    checkPin
  };
};

export default (connect(mapStateToProps, {})(ForgotPin));
